const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://gaming-ecommerce-backend.vercel.app/api';

export const API_ENDPOINTS = {
  products: `${API_BASE_URL}/products`,
  orders: `${API_BASE_URL}/orders`,
  users: `${API_BASE_URL}/users`,
  riders: `${API_BASE_URL}/riders`,
  cart: `${API_BASE_URL}/cart`
};

export default {
  API_BASE_URL,
  API_ENDPOINTS,
}; 